module.exports = __webpack_public_path__ + "img/extension_sales.c9aea0d6.png";